var map = {
	"./brother_marcus/UK/custom_rules.json": [
		7488,
		7488
	],
	"./brother_marcus_south_ken/UK/custom_rules.json": [
		1099,
		1099
	],
	"./honest_burger/UK/custom_rules.json": [
		5781,
		5781
	],
	"./sushi_dog/UK/custom_rules.json": [
		1811,
		1811
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 9851;
module.exports = webpackAsyncContext;